import { IconButton } from "../../../../common/components/button/iconButton/IconButton";
import { IconType } from "../../../../common/icons/Icon";
import styles from "./PlannerEventMeeting.module.scss";
import { SectionInfoRow } from "../../../../common/components/common/SectionInfoRow";
import { copyToClipboard } from "../../../../common/utilities/clipboardUtility";
import {
  getErrorToast,
  getSuccessToast,
} from "../../../../common/infrastructure/utilities/toastUtility";

interface IPlannerEventMeetingProps {
  meetingUrl?: string | null;
}

/**
 * The Google Meet row of a remote event: the link (opens in a new tab) with a copy button,
 * or, while the owner has not connected a Google account, a hint on how to get a link.
 */
export const PlannerEventMeeting = ({
  meetingUrl,
}: IPlannerEventMeetingProps) => {
  const url = meetingUrl?.trim();

  const onCopyClick = async () => {
    if (!url) return;

    const success = await copyToClipboard(url);

    if (success) {
      getSuccessToast("Линкът е копиран в клипборда!");
    } else {
      getErrorToast("Грешка при копиране на линка");
    }
  };

  if (!url) {
    return (
      <p className={styles.warning} role="note">
        Няма Meet линк. Собственикът трябва да свърже Google акаунта си в „Моят
        профил“.
      </p>
    );
  }

  return (
    <SectionInfoRow
      label={"Google Meet"}
      isLoading={false}
      data={
        <span className={styles.link}>
          <a
            className={styles.link_url}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Отвори срещата
          </a>
          <IconButton
            iconType={IconType.Copy}
            iconWidth="20px"
            iconHeight="20px"
            tooltip="Копирай линка"
            ariaLabel="Копирай линка"
            onClick={onCopyClick}
          />
        </span>
      }
    />
  );
};
